import type { LoginRequest, Me, PlatformLoginRequest, RegisterRequest, Session } from '@mezha/api'
import { baseApi } from '../baseApi'
import { http, session } from '../client'

export const authApi = baseApi.injectEndpoints({
  endpoints: b => ({
    me: b.query<Me, void>({ query: () => ({ get: '/api/v1/me' }), providesTags: ['Me'] }),
    login: b.mutation<Session, LoginRequest>({
      query: body => ({ post: '/api/v1/auth/login', body, auth: false }),
      onQueryStarted: async (_, { queryFulfilled }) => {
        try { session.set((await queryFulfilled).data) } catch { /* The form displays the request error. */ }
      },
    }),
    register: b.mutation<Session, RegisterRequest>({
      query: body => ({ post: '/api/v1/auth/register', body, auth: false }),
      onQueryStarted: async (_, { queryFulfilled }) => {
        try { session.set((await queryFulfilled).data) } catch { /* The form displays the request error. */ }
      },
    }),
    platformLogin: b.mutation<Session, PlatformLoginRequest>({
      query: body => ({ post: '/api/v1/auth/platform', body, auth: false }),
      onQueryStarted: async (_, { queryFulfilled }) => {
        try { session.set((await queryFulfilled).data) } catch { /* The form displays the request error. */ }
      },
    }),
  }),
})

/** Ends the session on the server (best effort) and locally; the cache is
 *  dropped by the session listener (app/store.ts). */
export async function logout(): Promise<void> {
  const refresh = session.refreshToken
  try {
    if (session.accessToken) await http.post('/api/v1/auth/logout', refresh ? { refresh_token: refresh } : {})
  } catch {
    /* the local session ends anyway */
  }
  session.clear()
}

export const { useMeQuery, useLoginMutation, useRegisterMutation, usePlatformLoginMutation } = authApi
